export default {
    state: {
      'bandsPayTypeText': ['', ''],
    },
    mutations: {
      'SET_BANDS_PAY_TYPE_TEXT': (state, viewFlagArr) => {
        state['bandsPayTypeText'] = viewFlagArr
      },
    },
    actions: {
      SetBandsPayTypeText({ commit }, viewFlagArr) {
        commit('SET_BANDS_PAY_TYPE_TEXT', viewFlagArr)
      }
    }
  }
  
  // this.$store.dispatch('SetMsg', '테스트 입니다.')
  // 가져올때: this.$store.state.ConnectedCar.msg
  